export const FEATURE_TOGGLES = {
  documents: 'landing-page:documents',
};
